import styled from "styled-components";
import { FontMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
export const ProductsBannerOrigins = styled.div.withConfig({
    displayName: "styled__ProductsBannerOrigins",
    componentId: "sc-6a44b04e-0"
})`
	text-align: center;
	margin-bottom: 20px;

	& > p {
		color: ${({ theme  })=>theme.colors.grays.dark};
		${FontMixin({
    size: 'base',
    weight: 'light',
    height: 'base'
})}
		margin-bottom: 10px;
	}
`;

//# sourceMappingURL=styled.js.map